import { ProductsComponent } from './products.component';
import { ProductsFilterComponent } from './filter/products-filter.component';
import { ProductDetailsComponent } from './product-details/product-details.component';

export const ProductsComponents = [
    ProductsComponent,
    ProductsFilterComponent,
    ProductDetailsComponent
];